import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import * as fromNotifications from './reducers/notification.reducer';
import { NotificationsEffects } from './effects/notification.effects';
import { NotificationsService } from './services/notification.service';
import { NotificationsStoreFacade } from './facades/notifications-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromNotifications.notificationsFeatureKey,
      fromNotifications.reducer
    ),
    EffectsModule.forFeature([NotificationsEffects]),
  ],
  providers: [NotificationsService, NotificationsStoreFacade],
})
export class NotificationsStoreModule {}
